import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!localStorage.getItem("adw-cookies")) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem("adw-cookies", value);
    setVisible(false);
    if (value === "accepted" && !pathname.startsWith("/admin")) {
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/visits`, { page: pathname }).catch(() => {});
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-2xl bg-[#0d0e20]/95 backdrop-blur-2xl border border-white/[0.1] p-5 shadow-2xl"
          data-testid="cookie-banner"
        >
          <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
            Ce site utilise des cookies de mesure d'audience pour améliorer votre expérience.{" "}
            <Link to="/confidentialite" className="text-[var(--accent-cyan)] hover:underline" data-testid="cookie-more-link">
              En savoir plus
            </Link>
          </p>
          <div className="flex gap-3 mt-4">
            <button
              onClick={() => choose("accepted")}
              className="btn-gradient rounded-full px-5 py-2 text-sm font-semibold text-white"
              data-testid="cookie-accept-btn"
            >
              Accepter
            </button>
            <button
              onClick={() => choose("refused")}
              className="glass rounded-full px-5 py-2 text-sm text-[var(--text-secondary)] hover:text-white transition-colors"
              data-testid="cookie-refuse-btn"
            >
              Refuser
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
